import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { buildJsonLd } from "@/config/schema";
import { useFormules } from "@/store/formules/FormulesProvider";

/**
 * Injection des données structurées JSON-LD, indépendante du gestionnaire
 * Open Graph / Twitter. Un seul script géré (identifiant stable) est conservé
 * dans le <head> et remplacé à chaque changement de route.
 *
 * Les prix repris dans les offres proviennent de Supabase (source de vérité),
 * afin qu'ils restent cohérents avec les tarifs affichés et modifiés par le
 * Super Admin.
 */
const SCRIPT_ID = "immo-seo-json-ld";

export default function JsonLdManager() {
  const { pathname } = useLocation();
  const { formules } = useFormules();
  const prixMensuels = formules.map((formule) => formule.prixMensuel);

  useEffect(() => {
    const data = buildJsonLd(pathname, prixMensuels);
    const existing = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null;

    if (!data) {
      if (existing) existing.remove();
      return;
    }

    const script = existing ?? document.createElement("script");
    script.id = SCRIPT_ID;
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(data);
    if (!existing) document.head.appendChild(script);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, prixMensuels.join(",")]);

  return null;
}